import {
  deleteApiTracksId,
  getApiTracksId,
  patchApiTracksIdUploadStatus,
  postApiTracks,
  putApiTracksId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const jingleByIdQuery = createQuery({
  handler: getApiTracksId,
})

export const jingleByIdUploadStatus = createMutation({
  handler: patchApiTracksIdUploadStatus,
})

export const jingleCreate = createMutation({
  handler: postApiTracks,
})

export const jingleUpdate = createMutation({
  handler: putApiTracksId,
})

export const jingleDelete = createMutation({
  handler: deleteApiTracksId,
})
